import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DemoImage from './DemoImage';

export default class OptimizedImage extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    transformation: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object)
    ]),
    title: PropTypes.string,
    reportImageSize: PropTypes.func.isRequired,
    showDetails: PropTypes.func.isRequired,
    size: PropTypes.number,
    baselineSize: PropTypes.number
  }

  constructor(props, context) {
    super(props, context);
    this.showDetails = this.showDetails.bind(this);
    this.handleHiddenComplete = this.handleHiddenComplete.bind(this);
    this.state = { hiddenSrc: null };
  }

  showDetails(transformation, format, children) {
    this.props.showDetails(transformation, this.props.format || format, children);
  }

  handleHiddenComplete() {
    let self = this;
    return function(e) {
      self.setState({...self.state, hiddenSrc: e.target.src});
    };
  }

  render() {
    let originalSize;
    let optimizedSizeKB = '';
    let anchorUrl = this.state.hiddenSrc;
    if (this.props.baselineSize) {
      originalSize = Math.round(this.props.baselineSize / 1024);
    }
    const optimizedSize = Math.round((this.props.size || 0) / 1024);
    const optimizationPercent = Math.round(100 * (1 - (this.props.size || 0) / (this.props.baselineSize || 1)));
    const title = this.props.title || 'Optimized';
    if (optimizedSize > 0) {
      optimizedSizeKB = optimizedSize + 'KB';
    }
    let saving = <strong className="saved-size">{optimizationPercent}% saving</strong>;
    if (this.props.hideSaving || optimizationPercent <=0 || optimizationPercent === 100) {
      saving = null;
    }
    const hiddenTransformation = {...this.props.transformation, fetch_format: null};

    return (
      <li>
        <div className="caption">
          <span className="title">{title}</span>
          <div className="bottom">
            <strong className="size">{optimizedSizeKB}</strong>
            {saving}
          </div>
        </div>
        <DemoImage publicId={this.props.publicId}
                   imageClassName="hidden"
                   style={{width: '100%', height: 0}}
                   transformation={hiddenTransformation}
                   format={this.props.format}
                   reportImageSize={this.props.reportImageSize}
                   id={this.props.id}
                   showDetails={this.showDetails}
                   showButton={false}
                   handleComplete={this.handleHiddenComplete()} >
          {this.props.children}
        </DemoImage>
        <DemoImage publicId={this.props.publicId}
                   className="img"
                   transformation={this.props.transformation}
                   format="jpg"
                   showDetails={this.showDetails}
                   anchorUrl={anchorUrl} >
          {this.props.children}
        </DemoImage>
      </li>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/OptimizedImage.js
 **/